import styled, { css } from 'styled-components';
import { RegionField } from '~/src/components/common-components/region-field/region-field';
import { Box } from '~/src/components/form-components/textbox/textbox.styles';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_1279 } from '~/src/styles/tokens/break-points';
import { rem } from '~/src/helpers/rem-converter.helper';

export const RegionDropdownWrap = styled(RegionField)`
    width: calc(50% - ${rem(16)});

    ${Box} {
        cursor: auto;
    }

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            width: 100%;
        `,
    )};
`;

export const AddressInfoBlockWrapper = styled.div`
    width: 100%;
    gap: ${rem(24)};
`;
